import React from "react";

// Images
import image1 from "../../images/about/viewgener-vision-city.png";
import image2 from "../../images/about/viewgener-global-ecosystem.png";
import image3 from "../../images/about/viewgener-founder-vision-v3.png";
import flyer from "../../images/about/FLYER.FRONT. PROMOTION LESSONS.jpg"

// Stylesheets
import "./About.scss";

const About = () => {
    return (
        <main className="about" id="about">
            <section className="first-section">
                <div className="info">
                    <span>VIEWGENER HOLDING COMPANY</span>
<h1>A VISION FOR<br />GENERATIONS</h1>
                    <div className="text">
                        <p>
        ViewGeneR is a holding company built around a long-term vision:
        creating, developing and connecting businesses across industries.
    </p>

    <p>
        We transform ideas into opportunities through innovation,
        strategic partnerships and ventures designed to create lasting
        value for generations.
    </p>
                    </div>
                </div>
                <div className="images">
                    <img src={image1} alt="" />
                </div>
            </section>
            <section className="second-section">
                <div className="info">
    <span>OUR VISION</span>

    <h1>CREATING GLOBAL ECOSYSTEMS</h1>

    <div className="vision-line"></div>

    <div className="vision-pillars">

        <div className="vision-pillar">
            <div className="vision-icon">◎</div>
            <div>
                <h3>People are our vision.</h3>
                <p>
                    We empower people through education, personal growth
                    and well-being, creating opportunities for generations
                    to thrive.
                </p>
            </div>
        </div>

        <div className="vision-pillar">
            <div className="vision-icon">◇</div>
            <div>
                <h3>Health &amp; performance.</h3>
                <p>
                    We develop science-driven health, nutrition and
                    performance solutions designed to enhance quality
                    of life.
                </p>
            </div>
        </div>

        <div className="vision-pillar">
            <div className="vision-icon">⊕</div>
            <div>
                <h3>Opportunities &amp; impact.</h3>
                <p>
                    We build businesses and strategic partnerships that
                    create economic opportunity and lasting global impact.
                </p>
            </div>
        </div>

    </div>

    <p className="vision-closing">
        United by vision and purpose, we create value for generations to come.
    </p>
</div>
                <div className="images">
                    <img src={image2} alt="" />
                </div>
            </section>
            <section className="third-section">
                <div className="info">
                    <span>FROM THE FOUNDER</span>
<h1>BUILDING BEYOND GENERATIONS</h1>
<div className="text">
  <p>
    Our ambition is not simply to build businesses, but to create value,
    opportunities and ecosystems capable of enduring across generations.
  </p>
  <p><b>René Valencia</b></p>
  <p><b>FOUNDER & CEO</b></p>
  <p><b>ViewGeneR Holding Company</b></p>
</div>
                    </div>
                <div className="images">
                    <img src={image3} alt="" />
                </div>
            </section>
        </main>
    );
};

export default About;